import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [doctor, setDoctor] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("dotmedy_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const res = await api.get("/auth/me");
      setDoctor(res.data.doctor);
    } catch (e) {
      localStorage.removeItem("dotmedy_token");
      setDoctor(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("dotmedy_token", res.data.token);
    setDoctor(res.data.doctor);
    return res.data.doctor;
  };

  const register = async (payload) => {
    const res = await api.post("/auth/register", payload);
    localStorage.setItem("dotmedy_token", res.data.token);
    setDoctor(res.data.doctor);
    return res.data.doctor;
  };

  const logout = () => {
    localStorage.removeItem("dotmedy_token");
    setDoctor(null);
    window.location.href = "/";
  };

  return (
    <AuthContext.Provider value={{ doctor, loading, login, register, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
};
